import { render, staticRenderFns } from "./detailDocument.vue?vue&type=template&id=5b797344"
import script from "./detailDocument.vue?vue&type=script&lang=js"
export * from "./detailDocument.vue?vue&type=script&lang=js"
import style0 from "./detailDocument.vue?vue&type=style&index=0&id=5b797344&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports